import { useEffect, useState, Component } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Lenis from "lenis";
import Nav from "./components/Nav";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import Manifesto from "./components/Manifesto";
import Reel from "./components/Reel";
import WeekStrip from "./components/WeekStrip";
import Menu from "./components/Menu";
import Gallery from "./components/Gallery";
import InstaFeed from "./components/InstaFeed";
import Order from "./components/Order";
import OrderBuilder from "./components/OrderBuilder";
import Footer from "./components/Footer";
import Stamp from "./components/Stamp";

const INTRO_MS = 1050;

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-eggshell">
          <p className="font-display text-2xl">Something crumbled — refresh the page.</p>
        </div>
      );
    }
    return this.props.children;
  }
}

function Curtain() {
  return (
    <motion.div
      className="fixed inset-0 z-[100] bg-ink flex items-center justify-center"
      initial={{ y: 0 }}
      exit={{ y: "-100%" }}
      transition={{ duration: 0.85, ease: [0.76, 0, 0.24, 1] }}
    >
      <motion.div
        initial={{ scale: 0.7, opacity: 0, rotate: -8 }}
        animate={{ scale: 1, opacity: 1, rotate: 0 }}
        transition={{ duration: 0.55, ease: [0.16, 1, 0.3, 1] }}
      >
        <Stamp light size={150} spin={false} />
      </motion.div>
    </motion.div>
  );
}

export default function App() {
  const [booted, setBooted] = useState(false);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    const t = setTimeout(() => setBooted(true), INTRO_MS);
    return () => {
      cancelAnimationFrame(raf);
      clearTimeout(t);
      lenis.destroy();
    };
  }, []);

  return (
    <ErrorBoundary>
      <div className="grain bg-eggshell text-ink min-h-screen">
        <AnimatePresence>{!booted && <Curtain />}</AnimatePresence>
        <Nav />
        <main>
          <Hero />
          <Marquee />
          <Manifesto />
          <Reel />
          <WeekStrip />
          <Menu />
          <Gallery />
          <InstaFeed />
          <Order />
        </main>
        <Footer />
        <OrderBuilder />
      </div>
    </ErrorBoundary>
  );
}
